import * as React from 'react';
import classNames from 'classnames';
import Button, {IButtonProps} from '../Button';
import Icon, { IconsAvailable } from '../Icon';

import './styles.scss';
import {PropsWithChildren} from "react";

export interface IProductCampaignProps extends PropsWithChildren {
    img?: string;
    icon?: IconsAvailable;
    button?: IButtonProps;
    title?: string;
    theme?: 'theme01' | 'theme02' | 'theme03' | 'theme04' | 'theme05' | 'theme06' | 'theme07' | 'theme08' | 'info' | 'danger' | 'success' | 'warn' | 'discrete' | 'frameless';
}

const ProductCampaign: React.FunctionComponent<IProductCampaignProps> = (props) => {

    return (
        <div className={classNames('product-campaign', props.theme)}>
            {(props.img || props.icon) && (
                <div className="product-campaign__image">
                    {props.img && (<img src={props.img} alt={props.title ?? ''}/>)}
                    {props.icon && (<Icon kind={props.icon} height={32} width={32}/>)}
                </div>
            )}

            <div className="product-campaign__inner">
                <div className="product-campaign__text">
                    <React.Fragment>{props.children}</React.Fragment>
                </div>
                {props.button && (
                    <div className="product-campaign__action">
                        <Button
                            {...props.button}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

ProductCampaign.displayName = 'ProductCampaign';

export default ProductCampaign;
